import React, { useState } from "react";
import { useRouter } from "next/router";
import { get } from "../../../lib/api";
import { useToast } from "../../../context/toastContext";
import * as Sentry from "@sentry/nextjs";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const router = useRouter();
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const handleClick = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const response = await get("/api/v1/password_reset?email=" + email);
      if (response) {
        toast("success", "You will now be redirected to Sign In", null, () => {
          setLoading(false);
          router.push("/users/sign_in");
        });
      }
    } catch (err) {
      if (err?.data?.error) {
        toast("error", "There has been an " + err?.data?.error);
      } else {
        toast("error", "There has been an " + err);
      }
      setLoading(false);
      
      if (err?.status === 500){
        Sentry.captureException(err);
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Forgot Your Password?
          </h2>
          <h3>
            Please enter the email associated with your Vinous account. We will
            send you an email to reset your password.
          </h3>
        </div>
        <form className="mt-8 space-y-6" action="#" method="POST">
          <input type="hidden" name="remember" value="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-red focus:border-red focus:z-10 sm:text-sm"
                placeholder="Email address"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
              />
            </div>
          </div>

          <div>
            <button
              type="button"
              className={`${
                loading && "disabled"
              } group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red hover:bg-red focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red`}
              onClick={(e) => handleClick(e)}
            >
              {loading ? "Submiting..." : "Send me reset password instructions"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
